export default __webpack_public_path__ + "static/media/navbar-logo.199924e5.svg";